import React, { FC, useState, useEffect } from "react";

// ========== Utils ========== //
// ========== Hooks ========== //

export const HumanDashboardPage: FC = () => {

    return (
        <div className="flex flex-1 flex-col overflow-hidden h-full">
            <p>Báo cáo quản trị</p>
        </div>
    )
}